import { NoFavorites } from './no-favorites'
import React, { useState } from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { WorkoutPopup } from 'src/component/programmes/programme-workout-popup'
import { Grid } from 'src/component/ui/grid/grid'
import { PageTitle } from 'src/component/ui/page-title'
import { WorkoutCard } from 'src/component/ui/workout-card'
import { WorkoutCardSkeleton } from 'src/component/ui/workout-card/workout-card-skeleton'
import { Workout } from 'src/dao/core-dao'
import { useFavoriteWorkouts } from 'src/hook/use-favorite-workouts'
import { toasterUtil } from 'src/util/toaster-util'

export const ProfileFavoritesScreen = (): React.ReactElement => {
  const [selectedWorkout, setSelectedWorkout] = useState<Workout | undefined>(undefined)

  const {
    data: favoriteWorkoutsData = [],
    isLoading,
    isError,
  } = useFavoriteWorkouts({
    onError: () => {
      toasterUtil.error('We are having difficulties loading your favorites, please try again.')
    },
  })

  const favoriteWorkouts = favoriteWorkoutsData?.map((fw) => fw.workout) || []
  const hasFavoriteWorkouts = favoriteWorkouts && favoriteWorkouts.length > 0
  const noFavoriteWorkouts = !isLoading && !isError && !hasFavoriteWorkouts

  return (
    <PageContainer>
      <div className="py-6 md:py-[82px]">
        <div className="mb-10">
          <PageTitle>Favourites</PageTitle>
        </div>
        {isLoading || isError ? (
          <Grid.Skeleton count={6}>
            <WorkoutCardSkeleton />
          </Grid.Skeleton>
        ) : (
          <></>
        )}
        {noFavoriteWorkouts ? (
          <NoFavorites />
        ) : (
          <Grid
            items={favoriteWorkouts}
            keyExtractor={(w) => w.id}
            renderItem={(workout) => (
              <WorkoutCard.Favorites key={workout.id} workout={workout} onAction={() => setSelectedWorkout(workout)} />
            )}
          ></Grid>
        )}
      </div>
      <WorkoutPopup
        setOnClose={() => setSelectedWorkout(undefined)}
        selectedWorkout={selectedWorkout}
        startWorkoutLink={selectedWorkout ? `/workouts/${selectedWorkout?.id}` : undefined}
      />
    </PageContainer>
  )
}
